import React, { useState, useRef, useEffect } from 'react';
import { Flex, Text, IconButton, Box, Checkbox } from '@radix-ui/themes';
import { Cross1Icon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';

import './style.scss';

export default function Popup({ onClose }) {
  const [isToday, setIsToday] = useState(false);
  const popupRef = useRef(null);

  const handleCheckbox = () => {
    setIsToday(prev => !prev);
  };

  const handleClose = () => {
    onClose(isToday);
  };

  useEffect(() => {
    const popup = popupRef.current;
    if (!popup) return;

    const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    // 팝업 컨테이너 자체에 포커스(outline 없음) - Tab 누르기 전엔 포커스 링 미표시
    popup.focus();

    // Tab 키로 포커스가 팝업 밖으로 나가지 않도록 트랩
    const handleKeyDown = e => {
      if (e.key !== 'Tab') return;

      const focusableElements = Array.from(popup.querySelectorAll(focusableSelectors));
      if (focusableElements.length === 0) return;

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      // 팝업 컨테이너에 포커스가 있을 때 Tab → 첫 번째 요소로
      if (document.activeElement === popup) {
        e.preventDefault();
        if (e.shiftKey) {
          last.focus();
        } else {
          first.focus();
        }
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <Box className="main-popup" ref={popupRef} tabIndex={-1} style={{ outline: 'none' }}>
      {/* <Link to={`/promotion/detail/${process.env.NODE_ENV === 'development' ? '6947' : '7869'}`} title="홍보자료 상세 페이지로 이동"> */}
      <Link to="https://aichallenge4all.or.kr/" title="홍보자료 상세 페이지로 이동">
        <img src={require('assets/images/temp/main-popup.png')} alt="SW·AI 고교챌린지" />
      </Link>
      <Box className="popup-footer">
        <label>
          <Flex align="center" gap="var(--space-3)">
            <Checkbox id="today" checked={isToday} onCheckedChange={handleCheckbox} size="3" />
            <label htmlFor="today">
              <Text className="body2 font-basic" style={{ color: '#000' }}>
                오늘 하루 보지 않기
              </Text>
            </label>
          </Flex>
        </label>
      </Box>
      <IconButton variant="ghost" className="rt-variant-text close-btn" onClick={handleClose} aria-label="닫기" tabIndex={0}>
        <Cross1Icon color="white" width={36} height={36} aria-hidden="true" />
      </IconButton>
    </Box>
  );
}
